function getChunk(url, from, to, callback, errorback) {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', url);
  xhr.responseType = 'arraybuffer';
  xhr.setRequestHeader('Range', `bytes=${from}-${to}`);
  xhr.setRequestHeader('Cache-Control', 'no-store');

  xhr.onload = callback;
  xhr.onerror = errorback;
  xhr.onabort = errorback;
  xhr.send();
  return xhr;
}

function ChunkReader(url, totalSize, chunkSize) {
  this.totalSize = totalSize;
  this.chunkSize = Math.min(chunkSize, totalSize);
  this.url = url;
  this.fetchedData = 0;
  this.readPosition = 0;
}

ChunkReader.prototype.read = function (callback) {
  // Next chunk size should be less then bytes left to read
  let nextChunkSize = Math.min(this.chunkSize, this.totalSize - this.fetchedData);
  if (this.readPosition === this.totalSize) {
    callback();
    return;
  }
  this.activeXhr = getChunk(this.url, this.readPosition, this.readPosition + nextChunkSize - 1, (e) => {
    if (e.target.status === 206) {
      const data = new Uint8Array(e.target.response);
      this.fetchedData += data.length;
      this.readPosition += data.length;
      callback(data);
    } else {
      callback();
    }
  });
};

ChunkReader.prototype.stop = function () {
  this.activeXhr?.abort();
};

export default { ChunkReader };
